import React, { useEffect, useMemo, useState } from 'react'
import { TPerk } from '../../../context/types'
import { callApi, TApiResponse } from '../../../context/api'
import { Typography } from 'antd'
import './index.less'
import { useAuthContext } from '../../../context/auth'

const { Paragraph, Title, Link: AntLink } = Typography

const TopBanner = () => {
	const [promotedPerk, setPromotedPerk] = useState<TPerk>(null)
	const { auth } = useAuthContext()

	const fetchPromotedPerk = async () => {
		const perkResponse: TApiResponse = await callApi('perks/promoted', {
			method: 'GET',
		})

		const { data } = perkResponse.payload

		if (perkResponse.ok) {
			setPromotedPerk(data.perk)
		}
	}

	useEffect(() => {
		fetchPromotedPerk()
	}, [auth.user?.isExpert])

	const isVisible = useMemo(() => {
		return (promotedPerk?.available_for_experts && auth.user?.isExpert) || promotedPerk?.available_for_users
	}, [promotedPerk, auth.user])

	if (!isVisible) {
		return null
	}

	const PerkContent = () => (
		<div className="top-banner_container">
			<div className="img-wrapper">
				<img src={promotedPerk.img_url} alt={promotedPerk.name} />
			</div>
			<div className="text-content">
				<Title level={5}>{promotedPerk.name}</Title>
				<Paragraph>{promotedPerk.description}</Paragraph>
			</div>
		</div>
	)

	if (!auth.user) {
		return (
			<div className="top-banner">
				<PerkContent />
			</div>
		)
	}

	return (
		<AntLink
			href={auth.user?.isExpert ? promotedPerk.expert_url : promotedPerk.user_url}
			target="_blank"
			className="top-banner"
		>
			<PerkContent />
		</AntLink>
	)
}

export default TopBanner
